import { isRambleBrand } from "~/common/brand"
import { Logo } from "~/landing/components/logo"
import rambleWordmarkWhite from "~/images/brand/ramble-wordmark-white"

interface ShareLogoProps {
  analyticsProps?: Record<string, string | undefined>
}

export const ShareLogo = ({ analyticsProps }: ShareLogoProps) =>
  isRambleBrand() ? (
    <Logo
      src={rambleWordmarkWhite.src}
      alt="Ramble"
      className="h-[18px] md:h-[22px]"
      analyticsProps={analyticsProps}
    >
      {/* the wordmark is mark + word; the word starts 173/599 in, so the
          tagline is indented 1.65x the logo height to sit under the "R",
          and sized to end short of the "Ramble" word above it */}
      <span className="pl-[30px] font-sans text-[8px] leading-none tracking-n2 text-base-white opacity-70 md:pl-[36px] md:text-10">
        formerly ChatBCC
      </span>
    </Logo>
  ) : (
    <Logo className="h-[40px]" analyticsProps={analyticsProps} />
  )
